import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref, onMounted, onUnmounted } from "vue";
import screenfull from "screenfull";
import { ElMessage } from "element-plus";
export default {
  __name: 'Fullscreen',
  setup(__props) {
    const isFullscreen = ref(false);
    onMounted(() => init());
    onUnmounted(() => destroy());
    const handleFullScreen = () => {
      if (!screenfull.isEnabled) {
        ElMessage.error("you browser can not work");
        return false;
      }
      screenfull.toggle();
    };
    function change() {
      isFullscreen.value = screenfull.isFullscreen;
    }
    function init() {
      if (screenfull.isEnabled) {
        screenfull?.on("change", change);
      }
      isFullscreen.value = screenfull.isFullscreen;
    }
    function destroy() {
      if (screenfull.isEnabled) {
        screenfull?.off("change", change);
      }
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("i", {
        onClick: handleFullScreen,
        class: _normalizeClass(["iconfont height-100 flex-display flex-align-center", isFullscreen.value ? 'icon-quxiaoquanping' : 'icon-quanping'])
      }, null, 2);
    };
  }
};